import styled, { css } from "styled-components";
import { Button } from "antd";
import { theme } from "../../styles/theme";

const DISABLED_FILLED = css`
  &&[disabled],
  &&[disabled]:hover {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.light5};
    background-color: transparent;
    border-color: ${({ theme }) => theme.colors.light5};
    box-shadow: none;
  }
`;

export const CustomButton = styled(Button)`
  width: ${({ width }) => width || "175px"};
  height: ${({ height }) => height || "50px"};
  background: ${({ background }) => background || theme.colors.white} 0% 0%
    no-repeat padding-box;
  border-radius: ${({ radius }) => radius || "10px"};
  opacity: 1;
  color: ${({ color }) => color || theme.colors.white};
  font-size: ${({ size }) => size || theme.fonts.size.sm};
  font-weight: ${({ weight }) => weight || theme.fonts.weight.regular};
  border: 1px solid;
  border-color: ${({ border }) => border || "transparent"};

  && {
    .disabled {
      border: 1px solid ${theme.colors.light5};
      color: ${theme.colors.light5};
      background: transparent;
    }

    &.ant-btn-link {
      &:hover {
        color: ${({ color }) => color || theme.colors.white};
      }
    }

    &.ant-btn-default {
      &:hover {
        color: ${({ color }) => color || theme.colors.white};
        border: 1px solid;
        border-color: ${({ border }) => border || "transparent"};
      }
    }
  }
  ${DISABLED_FILLED}
`;
